import { defineCollection } from "@rebasepro/cms-types";
import { personName, playerOf } from "../people";

// Someone who blocked someone else (songbuzz_friend_block): they're no longer friends and can't be asked again. A
// report is a block too. backend/src/friends.ts creates and writes it.
const blocksCollection = defineCollection({
    name: "Blocks",
    singularName: "Block",
    slug: "blocks",
    table: "songbuzz_friend_block",
    description: "Who blocked whom. A blocked person can't send a friend request again.",
    securityRules: [
        { operation: "select", roles: ["admin"] },
        { operation: "delete", roles: ["admin"] },
    ],
    properties: {
        who: { name: "Blocked by (id)", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        blocked: { name: "Blocked (id)", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        blocker: playerOf("Blocked by", "who", "blocker"),
        blockedPlayer: playerOf("Blocked", "blocked", "blockedPlayer"),
        at: { name: "When", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
    },
    admin: {
        icon: "Ban",
        group: "Players",
        openEntityMode: "side_panel",
        sort: ["at", "desc"],
        display: {
            title: async ({ entity, context }) => `${await personName(context, entity.values.who)} blocked ${await personName(context, entity.values.blocked)}`,
            date: "at",
        },
        form: {
            sections: [
                { key: "block", properties: ["blocker", "blockedPlayer", "at"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["who", "blocked"] },
            ],
        },
    },
});

export default blocksCollection;
